import type { TranslationKey } from "@/translations"

export type Translate = (key: TranslationKey, vars?: Record<string, string | number>) => string

const FIELD_LABELS: Record<string, TranslationKey> = {
  "worker.phone": "fieldWorkerPhone",
  "worker.mobilePhone": "fieldWorkerMobilePhone",
  "worker.homePhone": "fieldWorkerHomePhone",
  "worker.businessPhone": "fieldWorkerBusinessPhone",
  "workerOrganization": "fieldOrganization",
  "workerOrganization.legalName": "fieldOrganizationLegalName",
  "workerOrganization.displayName": "fieldOrganizationDisplayName",
  "workerOrganization.type": "fieldOrganizationType",
  "workerOrganization.countryOfRegistration": "fieldOrganizationCountryOfRegistration",
  "workerOrganization.defaultTaxProvince": "fieldOrganizationDefaultTaxProvince",
  "workerOrganization.businessNumber": "fieldOrganizationBusinessNumber",
  "workerOrganization.address.addressLine1": "fieldOrganizationAddressLine1",
  "workerOrganization.address.addressLine2": "fieldOrganizationAddressLine2",
  "workerOrganization.address.city": "fieldOrganizationCity",
  "workerOrganization.address.country": "fieldOrganizationCountry",
  "workerOrganization.address.subdivision": "fieldOrganizationSubdivision",
  "workerOrganization.address.postalCode": "fieldOrganizationPostalCode",
  "workerOrganization.paymentNotificationEmail": "fieldOrganizationPaymentNotificationEmail",
}

/** The label for a field the preflight reports, or null for a field this map does not know. */
export function fieldLabelKey(field: string): TranslationKey | null {
  return FIELD_LABELS[field] ?? null
}

// The server states the width rule as "maximum N <unit>; this is M". Only that shape is rewritten: the rule
// text itself travels back unchanged in the acceptance, so this is display only.
const TOO_LONG = /^maximum (\d+) (characters|digits); this is (\d+)$/

/** The rule as the panel shows it: the width rule in the short form, everything else as the server said it. */
export function shortRule(rule: string, t: Translate): string {
  const match = TOO_LONG.exec(rule)
  if (!match) return rule

  const [, max, unit, actual] = match
  return t("shortRuleTooLong", {
    actual,
    max,
    unit: t(unit === "digits" ? "unitDigits" : "unitCharacters"),
  })
}
